export const toggleswitch = {
  root: {
    width: "35px",
    height: "20px",
    borderRadius: "30px",
    gap: "{gap.4}",
    shadow: "{form.field.shadow}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
    borderWidth: "{border.width.1}",
    borderColor: "transparent",
    hoverBorderColor: "transparent",
    checkedBorderColor: "transparent",
    checkedHoverBorderColor: "transparent",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    slideDuration: "{transition.duration}",
  },
  handle: {
    borderRadius: "50%",
    size: "14px",
  },
  colorScheme: {
    light: {
      root: {
        background: "{surface.border-input}",
        disabledBackground: "{form.field.disabled.background}",
        hoverBackground: "{surface.bg-grey-contrast}",
        checkedBackground: "{primary.support}",
        checkedHoverBackground: "{primary.default}",
      },
      handle: {
        background: "{surface.bg-white}",
        disabledBackground: "{form.field.disabled.color}",
        hoverBackground: "{surface.bg-white}",
        checkedBackground: "{surface.bg-white}",
        checkedHoverBackground: "{surface.bg-white}",
        color: "{text.body}",
        hoverColor: "{text.body}",
        checkedColor: "{primary.default}",
        checkedHoverColor: "{primary.support}",
      },
    },
    dark: {
      root: {
        background: "{surface.border}",
        disabledBackground: "{form.field.disabled.background}",
        hoverBackground: "{surface.border-input}",
        checkedBackground: "{primary.support}",
        checkedHoverBackground: "{primary.background}",
      },
      handle: {
        background: "{surface.bg-white}",
        disabledBackground: "{form.field.disabled.color}",
        hoverBackground: "{surface.bg-white}",
        checkedBackground: "{surface.bg-white}",
        checkedHoverBackground: "{surface.bg-white}",
        color: "{text.body}",
        hoverColor: "{text.body}",
        checkedColor: "{primary.default}",
        checkedHoverColor: "{primary.support}",
      },
    },
  },
  extend: {
    ui: {
      sm: {
        width: "26px",
        height: "16px",
        gap: "3px",
        handle: {
          size: "11px",
        },
      },
      colorScheme: {
        light: {
          root: {
            disabledCheckedBackground: "{primary.disabled}",
          },
          handle: {
            disabledCheckedBackground: "{surface.bg-white}",
          },
        },
        dark: {
          root: {
            disabledCheckedBackground: "{primary.disabled}",
          },
          handle: {
            disabledCheckedBackground: "{surface.bg-white}",
          },
        },
      },
    },
  },
  css: ({ dt }: any): string => `
    p-toggleswitch + label {
      cursor: pointer;
    }

    .p-toggleswitch-small {
      width: ${dt("toggleswitch.ui.sm.width")};
      height: ${dt("toggleswitch.ui.sm.height")};
    }

    .p-toggleswitch-small .p-toggleswitch-handle {
      width: ${dt("toggleswitch.ui.sm.handle.size")};
      height: ${dt("toggleswitch.ui.sm.handle.size")};
      margin-block-start: calc(-1 * calc(${dt("toggleswitch.ui.sm.handle.size")} / 2));
    }

    .p-toggleswitch-small.p-toggleswitch-checked .p-toggleswitch-handle {
      inset-inline-start: calc(${dt("toggleswitch.ui.sm.width")} - calc(${dt("toggleswitch.ui.sm.handle.size")} + ${dt("toggleswitch.ui.sm.gap")}));
    }

    .p-toggleswitch.p-disabled.p-toggleswitch-checked .p-toggleswitch-slider {
      background-color: ${dt("toggleswitch.ui.disabled.checked.background")};
    }

    .p-toggleswitch.p-disabled.p-toggleswitch-checked .p-toggleswitch-handle {
      background-color: ${dt("toggleswitch.ui.handle.disabled.checked.background")};
    }
  `,
};
